import DateUtils from '../../utils/DateUtils';
import {ReactComponent as AsteriskIcon} from '../../icons/asterisk.svg';
import {ReactComponent as CrossIcon} from '../../icons/cross.svg';

type TProps = {
    dateOfBirth?: Date;
    dateOfDeath?: Date;
}

const LifeDates = ({dateOfBirth, dateOfDeath}: TProps) => {
    const dottedDateOfBirth = dateOfBirth ? DateUtils.getDottedDate(dateOfBirth) : null;
    const dottedDateOfDeath = dateOfDeath ? DateUtils.getDottedDate(dateOfDeath) : null;

    return (
        <div className="cr-flex cr-gap cr-text-secondary">
            {dottedDateOfBirth &&
                <span>
                    <AsteriskIcon/> {dottedDateOfBirth}
                </span>
            }
            {dottedDateOfDeath &&
                <span>
                    <CrossIcon/> {dottedDateOfDeath}
                </span>
            }
        </div>
    )
}

export default LifeDates;
